import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { MonedaSelect } from 'sharedComponents/select'

const MonedaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='MONEDA' htmlFor='select-monedaPago' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='monedaPago'>
          {({ field }) => (
            <MonedaSelect {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-monedaPago' />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MonedaFormGroup)
